
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otp-login",
      function () {
        return require("private-next-pages/otp-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otp-login"])
      });
    }
  